import { action, ActionType } from "typesafe-actions";
import { SearchResults } from "../../../types/search/search-results.interface";
import { FlyerTemplateCreatorActionsType } from "../pages/flyer-template-creator/store/flyer-template-creator.actions";
import { IFlyerFilterOptions } from "../types/flyer-state/flyer-state.interface";
import { IFlyerFilters } from "../types/flyer-filter.interface";
import { IFlyerDetailData } from "../types/flyer-detail-data/flyer-detail-data.interface";
import { FlyerDetailActionType } from "../pages/flyer-detail/store/flyer-detail.actions";
import { Nullable } from "../../../types/common";
import { IError } from "../../../redux/actions/errorHandlingAction";
import { FlyerCreateForm } from "../types/flyer-create-form/flyer-create-form.interface";

import { push } from "connected-react-router";
import { PAGES } from "../../../features/navigation/types/pages.constant";
import mapParameters from "../../../utils/mapParameters";
import { IPermissions } from "../../../types/user/permissions/ipermissions/ipermissions.interface";
import { IUser } from "../../../types/user/iuser.interface";

export enum FlyerActions {
  ClearErrors = "Flyer/ClearErrors",

  Create = "Flyer/Create",
  CreateSuccess = "Flyer/CreateSuccess",
  CreateFailure = "Flyer/CreateFailure",

  Delete = "Flyer/Delete",
  DeleteFailure = "Flyer/DeleteFailure",
  DeleteSuccess = "Flyer/DeleteSuccess",

  Fetch = "Flyer/Fetch",
  FetchFailure = "Flyer/FetchFailure",
  FetchSuccess = "Flyer/FetchSuccess",

  SetGridView = "Flyer/SetGridView",

  SetModalOpenState = "Flyer/SetModalOpenState",

  InitPermissions = "Flyer/InitPermissions",
  SetPermissions = "Flyer/SetPermissions",

  FetchFilterOptions = "Flyer/FetchFilterOptions",
  FetchFilterOptionsFailure = "Flyer/FetchFilterOptionsFailure",
  SetFilterOptions = "Flyer/SetFilterOptions",
}

export const clearErrors = () => action(FlyerActions.ClearErrors);

export const create = (form: FlyerCreateForm) => action(FlyerActions.Create, form);
export const createFailure = (error: Nullable<IError>) => action(FlyerActions.CreateFailure, error);
export const createSuccess = (flyer: IFlyerDetailData) => action(FlyerActions.CreateSuccess, flyer);

export const deleteFlyer = (id: number) => action(FlyerActions.Delete, id);
export const deleteFlyerFailure = (error: Nullable<IError>) =>
  action(FlyerActions.DeleteFailure, error);
export const deleteFlyerSuccess = () => action(FlyerActions.DeleteSuccess);

export const fetch = (filters: Nullable<IFlyerFilters>) => action(FlyerActions.Fetch, filters);
export const fetchFailure = (error: Nullable<IError>) => action(FlyerActions.FetchFailure, error);
export const fetchSuccess = (results: SearchResults<IFlyerDetailData>, filters: IFlyerFilters) =>
  action(FlyerActions.FetchSuccess, { results, filters });

export const navigateToFlyer = (id: number) => push(`${PAGES.FLYERS.URL}/${id}`);
export const navigateToListing = (filters: Nullable<IFlyerFilters>) =>
  push(`${PAGES.FLYERS.URL}/${mapParameters(filters, {})}`);

export const initPermissions = (user: IUser) => action(FlyerActions.InitPermissions, user);
export const setPermissions = (permissions: IPermissions) =>
  action(FlyerActions.SetPermissions, permissions);

export const setGridView = (gridView: boolean) => action(FlyerActions.SetGridView, gridView);

export const setModalOpenState = (value: boolean) => action(FlyerActions.SetModalOpenState, value);

export const fetchFilterOptions = () => action(FlyerActions.FetchFilterOptions);
export const fetchFilterOptionsFailure = () => action(FlyerActions.FetchFilterOptionsFailure);
export const setFilterOptions = (filterOptions: IFlyerFilterOptions) =>
  action(FlyerActions.SetFilterOptions, filterOptions);

const actionCreators = {
  clearErrors,

  create,
  createFailure,
  createSuccess,

  deleteFlyer,
  deleteFlyerFailure,
  deleteFlyerSuccess,

  fetch,
  fetchFailure,
  fetchSuccess,

  setGridView,
  setModalOpenState,

  initPermissions,
  setPermissions,

  fetchFilterOptions,
  fetchFilterOptionsFailure,
  setFilterOptions,
};

export type FlyerActionType =
  | ActionType<typeof actionCreators>
  | FlyerTemplateCreatorActionsType
  | FlyerDetailActionType;
